/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/142-key': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11 0a5 5 0 00-4.916 5.916L0 12v3a1 1 0 001 1h1v-1h2v-2h2v-2h2l1.298-1.298A5 5 0 1011 0zm1.498 5.002a1.5 1.5 0 11.001-3.001 1.5 1.5 0 01-.001 3.001z"/>'
  }
})
